/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Hero_ErrorInputs */

const en_us2_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's workout could not be loaded.`)
};

const pt_br2_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o treino de hoje.`)
};

const es_419_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el entrenamiento de hoy.`)
};

const pt_pt2_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o treino de hoje.`)
};

const fr_fr2_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la séance du jour.`)
};

const de_de2_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das heutige Training konnte nicht geladen werden.`)
};

const it_it2_today_hero_error = /** @type {(inputs: Today_Hero_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare l'allenamento di oggi.`)
};

/**
* | output |
* | --- |
* | "Today's workout could not be loaded." |
*
* @param {Today_Hero_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_hero_error = /** @type {((inputs?: Today_Hero_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Hero_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_hero_error(inputs)
	if (locale === "es-419") return es_419_today_hero_error(inputs)
	if (locale === "pt-PT") return pt_pt2_today_hero_error(inputs)
	if (locale === "fr-FR") return fr_fr2_today_hero_error(inputs)
	if (locale === "de-DE") return de_de2_today_hero_error(inputs)
	if (locale === "it-IT") return it_it2_today_hero_error(inputs)
	return en_us2_today_hero_error(inputs)
});
export { today_hero_error as "today.hero_error" }